module.exports = __webpack_public_path__ + "img/1519981088.94d29cb0.jpg";